import { IApiOrderLifetimeProfile, IApiOrderLifetimeProfilesDefault, IApiUpdateOrderLifetimeProfileReq } from '@cbridge-packages/api';
import { IOrderLifetime, IOrderLifetimeDefault } from './orderLifetime.interface';

export namespace OrderLifetimeTranslator {
  export function fromApi(orderLifetime: IApiOrderLifetimeProfile): IOrderLifetime {
    return {
      orderLifetimeId: orderLifetime.id,
      name: orderLifetime.name,
      marketFokTimeout: orderLifetime.marketFokTimeout,
      marketIocTimeout: orderLifetime.marketIocTimeout,
      marketGtcTimeout: orderLifetime.marketGtcTimeout,
      limitFokTimeout: orderLifetime.limitFokTimeout,
      limitIocTimeout: orderLifetime.limitIocTimeout,
      limitGtcTimeout: orderLifetime.limitGtcTimeout,
    };
  }

  export function toApi(orderLifetime: IOrderLifetime): IApiUpdateOrderLifetimeProfileReq {
    return {
      id: orderLifetime.orderLifetimeId,
      name: orderLifetime.name,
      marketFokTimeout: orderLifetime.marketFokTimeout,
      marketIocTimeout: orderLifetime.marketIocTimeout,
      marketGtcTimeout: orderLifetime.marketGtcTimeout ?? undefined,
      limitFokTimeout: orderLifetime.limitFokTimeout,
      limitIocTimeout: orderLifetime.limitIocTimeout,
      limitGtcTimeout: orderLifetime.limitGtcTimeout ?? undefined,
    };
  }

  export function defaultFromApi(orderLifetime: IApiOrderLifetimeProfilesDefault): IOrderLifetimeDefault {
    return {
      marketFokTimeout: orderLifetime.marketFokTimeout,
      marketIocTimeout: orderLifetime.marketIocTimeout,
      marketGtcTimeout: orderLifetime.marketGtcTimeout,
      limitFokTimeout: orderLifetime.limitFokTimeout,
      limitIocTimeout: orderLifetime.limitIocTimeout,
      limitGtcTimeout: orderLifetime.limitGtcTimeout,
    };
  }
}
